import React, { useEffect, useState, useRef } from 'react';

import bgImage from 'assets/images/poster-bg.png';

import { Parallax, ParallaxBanner } from 'react-scroll-parallax';
import Slider from 'react-slick';

import { getBanners } from 'apis/mainApi';

function Poster() {
  const slickRef = useRef();
  const [currentSlider, setCurrentSlider] = useState(0);  // Slick 현재 슬라이드 state

  const [banner, setBanner] = useState([]);

  const getBannerList = async () => {
    await getBanners()
      .then((response) => {
        if (response.data.success) {
          setBanner(response.data.result);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getBannerList();
  }, []);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    speed: 500,
    infinite: true,
    dots: false,
    autoplay: true,
    afterChange: (index) => setCurrentSlider(index),
  };

  return (
    <section className="poster" id="hash-poster">
      <div className="text-rolling">
        <Parallax x={[0, -5]}>
          <p>
            <span className="marquee-style1">
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
            </span>
            <span lang="en" className="marquee-style2">
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
              <span lang="en">Shared Designer’s Lab</span>
            </span>
          </p>
        </Parallax>
      </div>
      {/* <div className="poster-contain"> */}
      <ParallaxBanner
        className="poster-contain"
        layers={[
          {
            image: bgImage,
            // amount: 0.125,
            amount: 0.1,
          },
        ]}
      >
        <div className="poster-wrap">
          <Slider ref={slickRef} {...settings} className="poster-slider">
            {/* <div className="poster-slider"> */}
            {banner && banner.length > 0 ? (
              banner.map((val, idx) => (
                <div className="poster-img" key={val.id + idx}>
                  <img
                    src={`${process.env.REACT_APP_URI}/${val.image}`}
                    alt=""
                  />
                </div>
              ))
            ) : (
              <div className="poster-img">
                {/* <img src="http://placehold.it/480x600" alt="" /> */}
                <img src="http://placehold.it/576x720" alt="" />
              </div>
            )}
            {/* </div> */}
          </Slider>
          <div className="slider-button">
            {banner && banner.length > 0 ? (
              banner.map((val, idx) => (
                <span
                  className={`${currentSlider === idx ? 'active' : ''}`}
                  onClick={() => slickRef.current.slickGoTo(idx)}
                />
              ))
            ) : (
              <span
                className="active"
                onClick={() => slickRef.current.slickGoTo(0)}
              />
            )}
          </div>
        </div>
      </ParallaxBanner>
      {/* </div> */}
    </section>
  );
}

export default Poster;
